/**
 * AT KYC Popup Module
 * Manages the identity verification popup UI
 */

(function() {
  'use strict';

  // DOM elements cache
  let elements = null;

  // Initialize DOM references
  function initElements() {
    if (elements) return elements;

    elements = {
      overlay: document.getElementById('at-kyc-popup'),
      closeBtn: document.querySelector('.at-popup-close'),
      title: document.getElementById('at-popup-title'),
      body: document.getElementById('at-popup-body'),
      loader: document.getElementById('at-popup-loader'),
      loaderText: document.getElementById('at-popup-loader-text'),
      error: document.getElementById('at-popup-error'),
      errorText: document.getElementById('at-popup-error-text'),
      success: document.getElementById('at-popup-success'),
      successText: document.getElementById('at-popup-success-text'),
      button: document.getElementById('at-popup-button')
    };

    // Setup close button
    if (elements.closeBtn) {
      elements.closeBtn.addEventListener('click', close);
    }

    // Close on overlay click
    if (elements.overlay) {
      elements.overlay.addEventListener('click', function(e) {
        if (e.target === elements.overlay) {
          close();
        }
      });
    }

    // Close on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && elements.overlay && elements.overlay.style.display !== 'none') {
        close();
      }
    });

    return elements;
  }

  /**
   * Open the popup with configuration
   * @param {Object} config - Configuration object
   * @param {string} config.title - Popup title
   * @param {string} config.content - HTML content for the body
   */
  function open(config = {}) {
    const el = initElements();
    if (!el.overlay) {
      console.error('[ATPopup] Popup element not found');
      return;
    }

    // Reset state
    hideLoader();
    hideError();
    hideSuccess();
    hideButton();

    // Set title
    if (config.title && el.title) {
      el.title.textContent = config.title;
    }

    // Set content
    if (config.content && el.body) {
      el.body.innerHTML = config.content;
    }

    // Show overlay
    el.overlay.style.display = 'flex';
    
    // Trigger animation
    setTimeout(() => {
      el.overlay.classList.add('at-popup-visible');
    }, 10);

    // Prevent body scroll
    document.body.style.overflow = 'hidden';
  }

  /**
   * Close the popup
   */
  function close() {
    const el = initElements();
    if (!el.overlay) return;

    // Remove visible class
    el.overlay.classList.remove('at-popup-visible');

    // Hide after animation
    setTimeout(() => {
      el.overlay.style.display = 'none';
      document.body.style.overflow = '';
    }, 300);
  }

  /**
   * Update popup content
   * @param {string} html - HTML content
   */
  function updateContent(html) {
    const el = initElements();
    if (el.body) {
      el.body.innerHTML = html;
    }
  }

  /**
   * Set popup title
   * @param {string} title - Title text
   */
  function setTitle(title) {
    const el = initElements();
    if (el.title) {
      el.title.textContent = title;
    }
  }

  /**
   * Show loader with message
   * @param {string} message - Loading message
   */
  function showLoader(message = 'Loading...') {
    const el = initElements();
    if (!el.loader) return;

    hideError();
    hideSuccess();

    if (el.loaderText) {
      el.loaderText.textContent = message;
    }

    el.loader.style.display = 'flex';
  }

  /**
   * Hide loader
   */
  function hideLoader() {
    const el = initElements();
    if (el.loader) {
      el.loader.style.display = 'none';
    }
  }

  /**
   * Show error message
   * @param {string} message - Error message
   */
  function showError(message) {
    const el = initElements();
    if (!el.error) return;

    hideLoader();
    hideSuccess();

    if (el.errorText) {
      el.errorText.textContent = message;
    }

    el.error.style.display = 'flex';
  }

  /**
   * Hide error message
   */
  function hideError() {
    const el = initElements();
    if (el.error) {
      el.error.style.display = 'none';
    }
  }

  /**
   * Show success message
   * @param {string} message - Success message
   */
  function showSuccess(message) {
    const el = initElements();
    if (!el.success) return;

    hideLoader();
    hideError();

    if (el.successText) {
      el.successText.textContent = message;
    }

    el.success.style.display = 'flex';
  }

  /**
   * Hide success message
   */
  function hideSuccess() {
    const el = initElements();
    if (el.success) {
      el.success.style.display = 'none';
    }
  }

  /**
   * Configure the action button
   * @param {string} text - Button text
   * @param {Function} onClick - Click handler
   * @param {boolean} disabled - Whether button is disabled
   */
  function setButton(text, onClick, disabled = false) {
    const el = initElements();
    if (!el.button) return;

    el.button.textContent = text;
    el.button.disabled = disabled;
    el.button.style.display = 'block';

    // Remove previous listeners by cloning
    const newButton = el.button.cloneNode(true);
    el.button.parentNode.replaceChild(newButton, el.button);
    elements.button = newButton;

    // Add new listener
    if (onClick && typeof onClick === 'function') {
      newButton.addEventListener('click', onClick);
    }
  }

  /**
   * Hide the action button
   */
  function hideButton() {
    const el = initElements();
    if (el.button) {
      el.button.style.display = 'none';
    }
  }

  // Public API
  const ATPopup = {
    open,
    close,
    updateContent,
    setTitle,
    showLoader,
    hideLoader,
    showError,
    hideError,
    showSuccess,
    hideSuccess,
    setButton,
    hideButton
  };

  // Expose globally
  window.ATPopup = ATPopup;

  console.log('[ATPopup] Module initialized');

})();
